import { useEffect, useState } from 'react';
import { getSystemInfo } from '../../services/system/systemInfoService.js';

export const useSystemInfo = () => {
    const [systemInfo, setSystemInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSystemInfo = async () => {
        try {
            const data = await getSystemInfo();
            setSystemInfo(data);
        } catch (err) {
            console.error(err);
            setError('Error al obtener la información del sistema');
        } finally {
            setLoading(false);
        }
        };

        fetchSystemInfo();
    }, []);

    return {
        systemInfo,
        loading,
        error
    };
}